import _ from 'lodash';

export const CUSTOMERS_WALL_LOCALFILTERS_DEFAULT = {
    sort: 'Name',
    globalNameFilter: '',
    namefilter: '',
    category: 1,
    onlymine: false,
};
export const CUSTOMERS_WALL_QUICKFILTER_DEFAULT = {
    sort: 'Name',
    globalNameFilter: '',
    namefilter: '',
    category: 1,
    onlymine: false,
    tagFilter: [],
};
export const CUSTOMERS_WALL_DEFAULT_STYLE = 'table';

export const MODELS_WALL_LOCALFILTERS_DEFAULT = {
    sort: 'Name',
    globalNameFilter: '',
    namefilter: '',
    onlymine: false,
    intown: 'all',
};
export const MODELS_WALL_QUICKFILTER_DEFAULT = {
    globalNameFilter: '',
    nameFilter: '',
    intown: 'all',
    onlymine: false,
    tagFilter: [],
    sort: 'Name',
    sortFolder: 'Name',
    showFeaturesQuickFilters: false,
    gender: 'all',
    featuresQuickFilters: {},
    departmentFilter: null,
    showSeasonFilter: null,
};
export const MODELS_WALL_DEFAULT_STYLE = 'cards';

/**
 * True se almeno un quick filter è diverso dal suo default, cioè se c'è qualcosa da resettare.
 * I valori assenti contano come default: le configurazioni salvate in local storage possono
 * essere più vecchie dei default correnti e non avere tutte le chiavi.
 */
export const hasQuickFiltersSet = (quickFilters, defaultQuickFilters) => {
    if (!quickFilters) {
        return false;
    }
    return Object.keys(defaultQuickFilters).some((key) => {
        const value = quickFilters[key];
        if (value === null || value === undefined) {
            return false;
        }
        return !_.isEqual(value, defaultQuickFilters[key]);
    });
};
